import { atom } from "recoil"

export const AtomBirthdayDisplay = atom({
    key:'ATOMBIRTHDAYDISPLAY',
    default:''
})
  